module.exports = __webpack_public_path__ + "img/f0ccbe0.png";